var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.user && (_vm.user.avatar || _vm.user.avatarThumbnail))?_c('b-avatar',{attrs:{"size":_vm.size,"src":_vm.user.avatarThumbnail}}):_c('b-avatar',{staticClass:"bg--primary",attrs:{"size":_vm.size,"text":_vm.customerInitials}})
}
var staticRenderFns = []

export { render, staticRenderFns }